import useMutationApi from 'src/api/useMutationApi';

interface RetryPurchaseOrderExtractionResponse {
  success: boolean;
  status: string;
  extractionResultId: string;
  stagedPurchaseOrderId?: string | null;
  errorDetails?: Record<string, unknown> | null;
}

const useRetryPurchaseOrderExtraction = (inboundEmailId: string) => {
  return useMutationApi<
    Record<string, never>,
    RetryPurchaseOrderExtractionResponse
  >({
    endpoint: `communications/inbound-emails/${inboundEmailId}/retry-purchase-order-extraction`,
    method: 'POST',
    successMessage: 'Purchase order extraction retried successfully',
    errorMessage: 'Failed to retry purchase order extraction',
  });
};

export default useRetryPurchaseOrderExtraction;
